import { IconBrandGithub, IconBrandInstagram,  IconBrandLinkedin, IconBrandYoutube } from "@tabler/icons-react";
// import { ReactComponent as CodeforcesIcon } from "./Assets/codeForces.svg";
// import Codeforces from "./Assets/Code_Forces.png";
import { Icon } from "@iconify/react";



const Info={
    name:"Jeevan Kumar Korra",
    stack:["Software Engineer","Full Stack Web Developer",  "Competitive Programmer", "Open Source Contributor"],
    bio: (
        <>
    I’m a backend-focused software engineer from{" "}
    <span className="text-gray-400">IIT Kharagpur</span>, experienced in building
    scalable APIs, distributed systems, and real-time web platforms. I enjoy
    solving performance-critical problems, designing cloud-native architectures,
    and translating complex ideas into reliable production systems.
  </>
      ),
}
const ProjectInfo=[
    
    {
        title:"Mekanika Website",
        desc: "MEKANIKA, the Official Mechanical Department Students Society at IIT Kharagpur, is a dynamic organization dedicated to fostering innovation and technical excellence among mechanical engineering students. As the web developer for MEKANIKA, I designed and developed the society's official website, which serves as a comprehensive hub for all activities, events, and resources related to the society. The website features dynamic routing, state management, and a user-friendly interface, providing seamless access to information about workshops, guest lectures, industrial visits, and technical competitions. By integrating advanced search functionalities and responsive design, I ensured the website meets the needs of both desktop and mobile users. This project highlights my skills in web development, particularly in React.js, Material-UI, and deployment on Vercel, making it a significant addition to my portfolio.",
        image:"Mekanika.png",
        live:true,
        ongoing: true,
        technologies:["React","Magic UI","Tailwind CSS","vercel"],
        link:"https://mekanikaiitkgp.org",
        github:"https://github.com/jeevan10017/Mekanika_website"
    },
   
    {
        title:"GnexFlow",
        desc:"A full-stack collaborative canvas with AI brush, video, and real-time sync. Features infinite canvas, pan/zoom, secure APIs, and WebRTC integration via Agora SDK. Optimized WebSocket payloads and backend cleanup for 20+ concurrent users.",
        image:"gnexflow.png",
        live:true,
        ongoing:true,
        technologies:["React","HTML5 Canvas","Rough.js","TensorFlow.js","Node.js","Socket.IO","Agora","MongoDB"],
        link:"https://gnexflow.vercel.app/",
        github:"https://github.com/jeevan10017/GnexFlow"
    },
    {
        title:"Geo-Health",
        desc:"A spatial database and GIS-based healthcare platform enabling hospital mapping and doctor specialization search. Built with PostgreSQL PostGIS, pgRouting for shortest paths, React Leaflet frontend, and QGIS workflows.",
        image:"geo-health.png",
        live:false,
        ongoing:true,
        technologies:["PostgreSQL","PostGIS","pgRouting","React","Leaflet","QGIS"],
        link:"https://github.com/jeevan10017/geo-health-gis-platform",
        github:"https://github.com/jeevan10017/geo-health-gis-platform"
    },
    {
        title:"CryptoPortfolio App",
        desc: "an ultimate solution app for managing, tracking, and transferring cryptocurrency assets with ease. Whether you're a seasoned crypto enthusiast or just getting started, our app provides an intuitive and feature-rich platform to keep your investments on track.Engineered wallet connection, token transfer, and watchlist features, providing real-time updates and secure transactions.",
        image:"CryptoPortfolio.png",
        live:true,
        ongoing: true,
        technologies:["React","Material UI","Firebase", "Chart js","Web3 js","Ether js"],
        link:"https://cryptoportfolio.vercel.app",
        github:"https://github.com/jeevan10017/Crypto-Portfolio-App"
    },
    {
        title:"Fault-Tolerant Distributed Database System",
        desc:"Designed distributed DB with sharding, replication, and consistent hashing. Built recovery for automatic shard restoration, REST APIs for operations, and containerized deployment with Docker Compose.",
        image:"DistributedDB.png",
        live:false,
        ongoing:true,
        technologies:["Node.js","Express","Docker","Docker Compose","REST API"],
        link:"https://github.com/jeevan10017/Distributed-Data-Management-System",
        github:"https://github.com/jeevan10017/Distributed-Data-Management-System"
    },
     {
        title:"UR DSA Journey",
        desc: "A web application where users can efficiently manage their DSA learning journey. Never forget a solution again of their practiced question. Organize, revise, and master Data Structures & Algorithms with personalized reminders.",
        image:"ur_dsa_journey.png",
        live:true,
        ongoing: true,
        technologies:["React","firebase","firebase functions","Send Grid","Tailwind Css"],
        link:"https://ur-dsa-journey.vercel.app/",
        github:"https://github.com/jeevan10017/ur_dsa_journey"
    },
    {
        title:"Kafka-like Distributed Message Broker",
        desc:"Implemented a broker from scratch with TCP sockets, concurrency, replication, and fault tolerance. Built partitioning, topic routing, lifecycle management, and message serialization for production-ready reliability.",
        image:"KafkaBroker.png",
        live:false,
        ongoing:true,
        technologies:["C++","TCP Sockets","Concurrency","Replication","Message Queues"],
        link:"https://github.com/jeevan10017/distributed-messaging-system",
        github:"https://github.com/jeevan10017/distributed-messaging-system"
    },
    {
        title:"AI Dasboard UI demo",
        desc: "Demo modern UI search engine like gemini interface. more classic UI/UX in this modern era. Its a static application without integration of backend. used for the demo only with hardcoded data. just representation of clean UI with modern design ",
        image:"new_UI.png",
        live:true,
        ongoing: false,
        technologies:["React","tailwindCSS","figma design"],
        link:"https://imago-task.vercel.app/",
        github:"https://github.com/jeevan10017/Imago_Task"
    },
   
    
    {
        title:"FITFLEX",
        desc: "FITFLEX is a full-stack application designed to provide custom exercise plans and progress tracking. The app features user authentication, profile management, and workout tracking functionalities. The frontend is built using React, while the backend is powered by Firebase. • Enhanced user interface by using Material UI, Tailwind CSS, and Framer Motion for dynamic visual engagement. Integrated Redux for state management and Zod for form validation, enhancing project robustness and reliability.",
        image:"FITFLEX.png",
        live:true,
        ongoing: true,
        technologies:["React-Vite","Firebase","Redux","Material UI","Zod","Framer Motion"],
        link:"https://befiteveryday.netlify.app/",
        github:"https://github.com/Open-Code-Crafters/FitFlux"
    },
    
]
const SkillInfo = [
  {
    title: "Programming Languages",
    skills: ["C", "C++", "Python", "JavaScript", "TypeScript"]
  },
  {
    title: "Frontend Development",
    skills: [
      "HTML5",
      "CSS3",
      "React.js",
      "Redux Toolkit",
      "Tailwind CSS",
      "Material UI",
      "Framer Motion",
      "Bootstrap",
      "Rough.js"
    ]
  },
  {
    title: "Backend & APIs",
    skills: [
      "Node.js",
      "Express.js",
      "REST APIs",
      "WebSockets",
      "Socket.IO",
      "Kafka",
      "Redis",
      "Firebase Functions"
    ]
  },
  {
    title: "Databases & Storage",
    skills: [
      "PostgreSQL",
      "PostGIS",
      "MySQL",
      "MongoDB",
      "Firebase",
      "pgRouting"
    ]
  },
  {
    title: "DevOps & Cloud",
    skills: [
      "Docker",
      "Kubernetes",
      "AWS (EC2, S3, IAM, CloudFront)",
      "GCP",
      "Azure",
      "GitHub Actions",
      "CI/CD Pipelines"
    ]
  },
  {
    title: "Testing & Optimization",
    skills: ["Jest", "Performance Tuning", "Scalability Optimization"]
  },
  {
    title: "Developer Tools",
    skills: [
      "Git",
      "GitHub",
      "Postman",
      "VS Code",
      "MongoDB Compass",
      "Vercel",
      "Netlify",
      "Docker Compose"
    ]
  },
  {
    title: "Specializations",
    skills: [
      "Distributed Systems",
      "Microservices",
      "System Design",
      "WebRTC",
      "Real-time Collaboration",
      "AI/ML Integration (TensorFlow.js)"
    ]
  }
];


const ExperienceInfo = [
      {
        role: "Full Stack Developer Intern",
        company: "Sarvin Appliances",
        date: "Jul 2025 - Aug 2025",
        desc: "Led development of Sarvin’s first e-commerce platform (sarvinindia.com). Built scalable MERN backend with 65+ APIs, optimized dashboards, designed React UI with Redux Toolkit, integrated AWS S3/CloudFront, and implemented Kafka-based async fulfillment.",
        skills:["MERN","AWS S3","CloudFront","Kafka","Redux Toolkit","RBAC","Authentication"],
        promotion:false
    },
    {
        role: "Full Stack Developer Intern",
        company: "Equvinoxis Technologies",
        date: "Nov 2024 - Mar 2025",
        desc: "Engineered a Crucial Homepage by creating admin and client‑side using MySQL and Redux, ensuring maintainability and scalability, And by now Utilized Azure for version control, AWS S3 bucket for the Image upload and Working upon advanced search bar.",
        skills: ["MySQl","Git","Reactjs", "Azure", "AWS S3", "Redux","Sequalize"],
        promotion: false
    },
    {
        role: "Project Admin",
        company: "Girl Script Summer Of Code",
        date: "Oct 2024 - Nov 2024",
        desc: "•	Led open‑source project, improving quality via documentation, bug fixes, and features; recognized as the most active Project Admin.	Collaborated with mentors to track progress and refine project plans, aligning with the overall vision and goals of the project. Managed the contribution workflow by overseeing PR reviews and merging contributions from over 100+ contributors in a month. Guided mentors and contributors, resolving technical and workflow queries on the server to ensure efficient collaboration",
        skills: ["GitHub","Git","Reactjs", "Firebase", "Javascript", "Framer Motion", "Sorting"],
        promotion: false
    },
    {
        role: "Web Head",
        company: "Mekanika, IIT Kharagpur",
        date: "Jul 2024 - Present",
        desc: "I led builded mekanika website from scratch and managing and guiding a team of 3 developers to create a dynamic and responsive website for the mechanical department students society at IIT Kharagpur. I implemented advanced search functionalities, dynamic routing, and state management to enhance user experience and ensure seamless access to information about workshops, guest lectures, and technical competitions.",
        skills: [ "React JS", "Material UI", "Vercel", "Fuse.js"],
        promotion: true 
    },
    {
        role: "Web secretary",
        company: "Mekanika, IIT Kharagpur",
        date: "Jul 2023 - Jul 2024",
        desc: "I led builded mekanika website from scratch  responsive website for the mechanical department students society at IIT Kharagpur. Conducted Various events for the students of Mechanical Engineering Department.I implemented advanced search functionalities, dynamic routing, and state management to enhance user experience and ensure seamless access to information about workshops, guest lectures, and technical competitions.",
        skills: [ "React JS", "Material UI", "Vercel", "Fuse.js"],
        promotion: true 
    },
    {
        role: "Core Team Member",
        company: "Open Code Crafters",
        date: "Jun 2024 - present",
        desc: " with the team of 2 developers,  a ReactVite-based website featuring custom exercise plans and progress tracking of a full-stack application of FITFLEX. I implemented user authentication, profile management, Daily Tasks, workout management, with the frontend built using React and the backend powered by firebase.",
        skills: ["Reactjs", "MySQL", "Firebase", "Redux", "zod", "Material UI"],
        promotion: false
    },
    {
        role: "Open Source Contributor",
        company: "Social Summer of Code",
        date: "Jun 2024 - Aug 2024",
        desc: " contributed to open-source projects by identifying and resolving 15+ bugs, raising issues, and optimised quality. Enhanced TrendTrove's product page usability by 40% using sorting, filtering, and customizable styling themes. Led SSOC's involvement in Quira's quest by developing and using Shepherd.js, increasing community participation",
        skills: ["Reactjs", "MySQL", "Javascript", "Framer Motion", "Sorting", "Filtering", "Shepherd.js"],
        promotion: false
    },


]
const socialLinks = [
    { link: "https://github.com/jeevan10017", icon: IconBrandGithub },
    { link: "https://www.linkedin.com/in/jeevan-kumar-korra-068726252/", icon: IconBrandLinkedin },
    { link: "https://www.instagram.com/jeevankumarkorra", icon: IconBrandInstagram }, 
    { link: "https://www.youtube.com/@jeevs-z7e", icon: IconBrandYoutube },
    { link: "https://codeforces.com/profile/vitality1", icon: "simple-icons:codeforces", isCustomIcon: true },
];

const Slugs = [
    "typescript",
    "materialui",
    // "spring",
    "javascript",
    // "dart",
    // "java",
    "react",
    // "angular",
    // "flutter",
    // "android",
    "html5",
    "css3",
    // "springboot",
    "mongodb",
    // "selenium",
    // "nodedotjs",
    "express",
    // "nextdotjs",
    "prisma",
    "mysql",
    "amazonaws",
    "postgresql",
    "firebase",
    // "nginx",
    "vercel",
    // "testinglibrary",
    // "jest",
    // "cypress",
    "docker",
    "git",
    // "jira",
    "github",
    "gitlab",
    "visualstudiocode",
    // "androidstudio",
    // "sonarqube",
    // "figma",
    "c++",
];
export { Info, ProjectInfo, SkillInfo, ExperienceInfo, socialLinks, Slugs };